module.exports = __webpack_public_path__ + "r-v3/img/download_white.0cdaaf8e.svg";